import React, { useContext, useState, useEffect } from "react";
import styled, { css } from "styled-components";

import { handlePlayPause, handleNext, handlePrev } from "../actions";
import UIManager from "../../../service/ui-manager";
import { PlayerStateContext } from "../../../provider";
import { Box, Row, Col } from "../../../comps";

import { IS_ELECTRON_APP } from "../../../config";

import {
  miniPlay,
  miniPause,
  miniNext,
  miniExpand,
} from "../../../theme/image";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  padding-top: 3%;
  padding-bottom: 3%;
  ${({ hovered }) =>
    hovered &&
    css`
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 70%,
        rgba(0, 0, 0, 0.7) 100%
      );
    `}
`;

const Content = styled(Col)`
  width: 90%;
  height: 90%;
  /* flexing */
  align-items: center;
  justify-content: space-between;
  opacity: ${({ hovered }) => (hovered ? 1 : 0)};
  /* change to 0 */
  cursor: ${({ hovered }) => (hovered ? "default" : "none")};
`;

const Top = styled(Row)`
  width: 90%;
  height: 10%;
  /* min-height:40px; */
  align-items: center;
  ${IS_ELECTRON_APP &&
  css`
    -webkit-app-region: no-drag;
  `}
`;

const Mid = styled(Row)`
  height: 70%;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  ${IS_ELECTRON_APP &&
  css`
    cursor: move;
    -webkit-app-region: drag;
  `}
`;

const Bottom = styled(Row)`
  width: 30%;
  height: 10%;
  justify-content: space-between;
  align-items: center;
  ${IS_ELECTRON_APP &&
  css`
    -webkit-app-region: no-drag;
  `}
`;

const Img = styled.img`
  flex-grow: 0;
  flex-shrink: 0;
  height: 100%;
  transform: rotate(${({ rotate180 }) => (rotate180 ? 180 : 0)}deg);
`;

const DragHead = styled(Box)`
  width: auto;
  height: 100%;
  flex-grow:1;
  ${IS_ELECTRON_APP &&
  css`
    -webkit-app-region: drag;
  `}
`;

export default () => {
  const [hoverInfo, setHoverInfo] = useState({
    hover: false,
    time: 0,
    funId: "",
  });
  const [playerState] = useContext(PlayerStateContext);
  const { hover, time, funId } = hoverInfo;
  const { isPlaying } = playerState;

  useEffect(() => {
    clearTimeout(funId);
    const id = setTimeout(() => {
      setHoverInfo({ hover: false, time });
    }, 2000);
    setHoverInfo({ hover, time, funId: id });
  }, [time]);

  const onMouseMove = () => {
    console.log("hovering over empty space");
    setHoverInfo({ hover: true, time: new Date().getTime(), funId });
  };

  return (
    <Wrapper hovered={hover}>
      <Content hovered={hover} onMouseMove={onMouseMove}>
        {/* show controls on hover ,otherwise pointer:cursor
       will show and button wont be shown */}
        <Top>
          <DragHead />
          <Img
            src={miniExpand}
            onClick={() => {
              if (hover) UIManager.exitMiniMode();
            }}
          />
        </Top>
        <Mid />
        <Bottom>
          <Img
            src={miniNext}
            rotate180={true}
            onClick={() => {
              if (hover) handlePrev();
            }}
          />
          <Img
            src={isPlaying ? miniPause : miniPlay}
            onClick={() => {
              if (hover) handlePlayPause();
            }}
          />
          <Img
            src={miniNext}
            onClick={() => {
              if (hover) handleNext();
            }}
          />
        </Bottom>
      </Content>
    </Wrapper>
  );
};
